import React from 'react'
import links from 'links'
import { useDevice } from 'device'
import { track } from 'analytics'

import { Button } from 'components/inputs'
import BottomBannerBase from 'compositions/landings/BottomBanner/BottomBanner'

import GetStartedButton from '../GetStartedButton/GetStartedButton'

import messages from './messages'


type BottomBannerProps = {
  className?: string
}

const BottomBanner: React.FunctionComponent<BottomBannerProps> = ({ className }) => {
  const { isMobile } = useDevice()

  const button = isMobile ? (
    <GetStartedButton
      style="gold-30"
      fullWidth
      placement="Page bottom"
    />
  ) : (
    <Button
      title={messages.buttonTitle}
      to={links.subscribe}
      size={56}
      width={320}
      onClick={() => {
        track('Banner click', {
          placement: 'Page bottom',
          content: 'Subscribe',
          action: 'link',
          link: links.subscribe,
        })
      }}
    />
  )

  return (
    <BottomBannerBase
      className={className}
      button={button}
    />
  )
}


export default BottomBanner
